import Flow from 'types/Flow';
import { SelfServiceAPISteps, SelfServiceSteps } from 'modules/selfServices/types/SelfServiceSteps';

import { FINAL_INSTRUCTIONS } from '../common';
import { SUMMARY, FINAL_INVOICE, SIGNATURE } from './common';

export type HomeCheckOutSteps =
  SelfServiceSteps.SUMMARY
  | SelfServiceSteps.FINAL_INVOICE
  | SelfServiceSteps.SIGNATURE
  | SelfServiceSteps.FINAL_INSTRUCTIONS;

const HOME_CHECK_OUT_STEPS: Flow<HomeCheckOutSteps> = {
  SUMMARY,
  FINAL_INVOICE: {
    ...FINAL_INVOICE,
    next: SIGNATURE.key,
  },
  SIGNATURE: {
    ...SIGNATURE,
    previous: FINAL_INVOICE.key,
    next: FINAL_INSTRUCTIONS.key,
    data: {
      ...SIGNATURE.data,
      isFinalizeStep: true,
    },
  },
  FINAL_INSTRUCTIONS: {
    ...FINAL_INSTRUCTIONS,
    apiKey: SelfServiceAPISteps.INSTRUCTIONS,
    previous: SIGNATURE.key,
  },
};

export default HOME_CHECK_OUT_STEPS;
